import script from "./CobranzaAccountPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CobranzaAccountPanel.vue?vue&type=script&setup=true&lang=js"

import "./CobranzaAccountPanel.vue?vue&type=style&index=0&id=c5fa13e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5fa13e6"]])

export default __exports__